export default __webpack_public_path__ + "static/media/popout-white.7cb2a179.svg";